import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

document.addEventListener("turbo:load", function() {
  const $fileInput = $("#js-upload-company-logo");

  if ($fileInput.length) {
    const uploadPath = $fileInput.data("upload-path");

    const fileDropzone = new Dropzone($fileInput.get(0), {
      url: uploadPath,
      dictDefaultMessage: "Logo hochladen.",
      dictCancelUpload: "Upload abbrechen",
      dictCancelUploadConfirmation: "Upload sicher abbrechen?",
      addRemoveLinks: true,
      dictRemoveFile: "",
      acceptedFiles: "image/jpeg,image/png,image/gif",
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
      uploadprogress(file, progress, bytesSent) {
        if (file.previewElement) {
          for (let node of file.previewElement.querySelectorAll(
            "[data-dz-uploadprogress]"
          )) {
            node.nodeName === "PROGRESS"
              ? (node.value = progress)
              : (node.style.width = `${progress}%`);
            $(".dz-progress").attr("data-value", `${progress.toFixed(2)}%`);
            $(".dz-upload").attr("data-value", `${progress.toFixed(2)}%`);
          }
        }
      },

      success: function (file, response) {
        window.location.reload();
      },

      error: function (file, response) {
        file.previewElement.classList.add("dz-error");
        console.log("error", response);
      },
    });
  }
});
